import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { Display } from "phaser";

const containerStyle = {
  width: "250px",
  aspectRatio: "2.5 / 3.5",
  borderRadius: "12px",
  position: "relative",
  perspective: 1000,
  cursor: "pointer",
  transformStyle: "preserve-3d", // ← critical!
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const faceStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: "12px",
  // backfaceVisibility: "hidden",
  backfaceVisibility: "hidden", // ← critical!
  WebkitBackfaceVisibility: "hidden",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export default function FlipCard({
  frontComponent,
  backImage,
  flipped,
  setFlipped,
}) {
  const controls = useAnimation();

  useEffect(() => {
    async function sequence() {
      // Pulse up shadow and scale
      await controls.start({
        scale: 1.1,
        boxShadow: "0px 4px 8px rgba(0,0,0,0.35)",
        transition: { duration: 0.15 },
      });
      // Rotate
      await controls.start({
        rotateY: flipped ? 180 : 0,
        transition: { duration: 0.4, ease: "easeInOut" },
      });
      // Settle back scale and shadow
      await controls.start({
        scale: 1,
        boxShadow: "0px 4px 4px rgba(0,0,0,0.1)",
        transition: { duration: 0.15 },
      });
    }
    sequence();
  }, [flipped, controls]);

  return (
    <motion.div
      style={containerStyle}
      initial={{
        rotateY: 0,
        scale: 1,
        boxShadow: "0px 4px 4px rgba(0,0,0,0.1)",
      }}
      animate={controls}
      onClick={() => setFlipped(!flipped)}
    >
      <img
        src={backImage}
        alt="card back"
        style={{
          ...faceStyle,
          transform: "rotateY(0deg)",
        }}
      />

      {/* FRONT FACE: starts hidden behind, then shows when container >= 90° */}
      <div
        style={{
          ...faceStyle,
          transform: "rotateY(180deg)",
        }}
      >
        {frontComponent}
      </div>
    </motion.div>
  );
}
